import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js'
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {

  private secretKey: string;

  constructor() {
    // Generate a random secret key or retrieve it from a secure source
    this.secretKey = environment.encryptionKey;
  }

  // Method to generate a random secret key
  private generateSecretKey(): string {
    return CryptoJS.lib.WordArray.random(16).toString();
  }

 
  encrypt(data: string): string {
  // Ensure key and IV are 16 bytes (AES-128)
  // console.log('secretKey',this.secretKey.padEnd(16, '0').slice(0, 16));
  
  const key = CryptoJS.enc.Utf8.parse(this.secretKey);
  const iv = CryptoJS.enc.Utf8.parse(this.secretKey);
  const encrypted = CryptoJS.AES.encrypt(data, key, { iv: iv });
  return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
}

decrypt(encryptedData: string): string {
  try {
    const key = CryptoJS.enc.Utf8.parse(this.secretKey);
    const iv = CryptoJS.enc.Utf8.parse(this.secretKey);
    const ciphertext = CryptoJS.enc.Base64.parse(encryptedData);
    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext: ciphertext } as any,
      key,
      { iv: iv }
    );
    const decryptedData = decrypted.toString(CryptoJS.enc.Utf8);
    if (!decryptedData) {
      throw new Error('Decryption failed');
    }
    return decryptedData;
  } catch (error) {
    console.error('Error during decryption:', error);
    return '';
  }
}

}
